import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  useLocation,
} from "react-router-dom";
import Login from "./components/auth/Login";
import SignUp from "./components/auth/SignUp";
import ForgotPassword from "./components/auth/ForgotPassword";
import ChangePass from "./components/auth/ChangePass";
import Chat from "./components/chat/Chat";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { setErrorCallbacks, verifyEmail } from "./service/api";
import {
  Alert,
  Container,
  Image,
  Navbar,
  Spinner,
} from "react-bootstrap";
import Logo from "./beatai-logo.svg";
import AIImage from "./components/chat/AIImage";
import AccountSettings from "./components/auth/AccountSettings";
import CookiePolicyFooter from "./components/chat/Cookies";
import AIWorkflows from "./components/workflows/Workflows";
import ErrorPage from "./components/ErrorPage";
import Subscription from "./components/auth/Subscription";
import Beats from "./components/beats/index";


function Verify() {
  const [isVerifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState({ code: 0 }); // 0 loading, 1: verified, 2: failed

  useEffect(() => {
    document.title = "BeatAI - Account Verification";
  }, []);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);

    if (query) {
      setVerifying(true);
      verifyEmail(query.get("token"))
        .then(() => {
          localStorage.setItem("verified", "true");
          setVerifying(false);
          setSuccess({ code: 1 });
        })
        .catch((e) => {
          setVerifying(false);
          setSuccess({ code: 2 });
        });
    }
  }, []);

  return (
    <>
      <Navbar
        sticky="top"
        bg="dark"
        variant="dark"
        expand="sm"
        className="w-100 m-0 nav_"
      >
        <Container fluid className="px-3">
          <Navbar.Brand className="ms-2">
            <Image src={Logo} style={{ maxWidth: "140px" }} />
          </Navbar.Brand>
        </Container>
      </Navbar>
      <Container className="text-center">
        {success.code == 0 && (
          <Alert>
            <Spinner size="sm" /> "Please wait..."
          </Alert>
        )}
        {success.code == 1 && (
          <Alert variant="dark">
            Account Verified! <a href="/chat">Navigate to Chat</a>
          </Alert>
        )}
        {success.code == 2 && (
          <Alert variant="dark">
            Failed to verify the link, either link is expired or is invalid!{" "}
            <a href="/chat">Resend</a> again from your account
          </Alert>
        )}
      </Container>
    </>
  );
}

function App() {
  const isAuthenticated = () => !!localStorage.getItem("accessToken");

  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login?sc=ef5199c2-e6b8-4257-9932-20aa6f449c90R" />
        )
      }
    />
  );

  const PublicRoute = ({ component: Component, ...rest }) => (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated()) {
          return <Redirect to="/chat/" />;
        } else {
          const query = new URLSearchParams(window.location.search);
          if (query) {
            if (query.get("sc") !== "ef5199c2-e6b8-4257-9932-20aa6f449c90R") {
              window.location = "https://www.beatai.io";
            }
          }
          return <Component {...props} />;
        }
      }}
    />
  );

  return (
    <>
      <div className={isAuthenticated() ? "" : "non-login-bg p-0"}>
        <Router>
          <Switch>
            <Route exact path="/verify-email" component={Verify} />
            <PrivateRoute exact path="/technical-error" component={ErrorPage} />
            <PublicRoute
              exact
              path="/password-reset-confirm/:token/"
              component={ChangePass}
            />
            <PublicRoute exact path="/login" component={Login} />
            <PublicRoute exact path="/signup" component={SignUp} />
            <PublicRoute
              exact
              path="/forgot-password"
              component={ForgotPassword}
            />
            <PrivateRoute exact path="/chat/" component={Chat} />
            <PrivateRoute exact path="/ai-images/" component={AIImage} />
            <PrivateRoute path="/chat/:chatId" component={Chat} />
            <PrivateRoute path="/ai-workflows" component={AIWorkflows} />
            <PrivateRoute path="/membership" component={Subscription} />
            <PrivateRoute path="/beats" component={Beats} />
            <PrivateRoute
              path="/account-settings/"
              component={AccountSettings}
            />
            <Redirect from="/" to="/login" />
          </Switch>
        </Router>
      </div>
      <CookiePolicyFooter />
    </>
  );
}

export default App;
